const headerTabs = {
  "header.tab.home": "Home",
  "header.tab.progress": "Progress",
  "header.tab.activity": "Activity",
  "header.tab.playlists": "Playlists",
  "header.tab.coach": "Coach",
};

const headerMenu = {
  "header.menu.rank": "Rank",
  "header.menu.bybiq": "BYB IQ",
  "header.menu.switch-profile": "Switch Profile",
  "header.menu.settings": "Settings",
  "header.menu.logout": "Sign out",
};

const demoAlert = {
  "header.demo-alert.message": "You are currently using a trial account",
  "header.demo-alert.expiry-line": "Your access expires on {{date}}",
};

const exitDialog = {
  "header.exit.switch-profile.title": "Switch Profile",
  "header.exit.exit.title": "Exit App",
  "header.exit.account.title": "Account",
  "header.exit.admin.title": "Admin",
  "header.exit.logout.title": "Sign Out",
};

const adminWebOverride = {
  "header.exit.admin.override": "Web Env Override",
  "header.exit.admin.current-url": "Current URL",
  "header.exit.admin.url": "URL",
  "header.exit.admin.add": "Add",
  "header.exit.admin.cached-urls": "Cached URLs",
  "header.exit.admin.load": "Load",
  "header.exit.admin.clear-url-cache": "Clear Url Cache",
  "header.exit.admin.other": "Other",
  "header.exit.admin.clear-app-cache": "Clear App Cache",
};

export const header = {
  ...headerTabs,
  ...headerMenu,
  ...demoAlert,
  ...exitDialog,
  ...adminWebOverride,
};
